import { useState } from 'react';
import TradeHistoryTable from '../../components/tables/TradeHistoryTable';
import { DUMMY_TRADE_HISTORY } from '../../dummy_data/Dummy_Transaction';
import Modal from '../../components/modal/Modal';
import AddNewTransactionCard from '../../components/card/AddNewTransactionCard';
import { NewTransactionDto } from '../../models/dto/transasctionDto';

const TradeHistoryPage = () => {
  const [showAddModal, setShowAddModal] = useState<boolean>(false);

  const addNewTransaction = (newTransactionDto: NewTransactionDto) => {};

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Trade History
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            A comprehensive log of all trading activity within your account,
            company involved, transaction details, and the associated profit or
            loss.
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 flex flex-row gap-x-2">
          <button
            type="button"
            className="block rounded-md bg-indigo-50 px-3.5 py-2.5 text-sm font-semibold text-indigo-600 shadow-sm hover:bg-indigo-100"
          >
            Export
          </button>
          <button
            type="button"
            onClick={() => {
              setShowAddModal(true);
            }}
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Add Transaction
          </button>
        </div>
      </div>
      {showAddModal && (
        <Modal
          onCloseClick={() => {
            setShowAddModal(false);
          }}
          isOpen={showAddModal}
        >
          <AddNewTransactionCard
            onCancelClick={() => {
              setShowAddModal(false);
            }}
            submitTransaction={addNewTransaction}
          />
        </Modal>
      )}
      <TradeHistoryTable
        onDeleteClick={() => {console.log('Delete')}}
        transactions={DUMMY_TRADE_HISTORY}
      />
    </div>
  );
};

export default TradeHistoryPage;
